type TaggerConfig = { endPoint?: string, [key: string]: any };
export default class TrackerConfig {
  static get endpoint() {
    return useRuntimeConfig().public.trackerEndpoint || 'http://127.0.0.1:9030';
  }

  static get scriptSrc() {
    return useRuntimeConfig().public.saSpJsUrl || 'http://127.0.0.1:3000/js/dl.js';
  }

  static prepareConfig(config: TaggerConfig) {
    config.endPoint = this.endpoint;
    return config;
  }

  static createTagger(appName: string, config: TaggerConfig) {
    window.atgDataLayer = [];
    const dl = window.atgDataLayer;
    const tagger = function (...args: any[]) {
      dl.push([appName, args.shift(), args]);
    }
    tagger('init', this.prepareConfig(config));
    tagger('setTrackingIpFilter', true);
    if (!dl.includes('SA SP initialized')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = this.scriptSrc;
      document.head.appendChild(script);
      dl.push('SA SP initialized')
    }
    return tagger;
  }
}
